import { FieldDef } from './../fields'
import { uuid } from '../uuid'
import { DependOnOption } from '../common'

export class GridDef {
  key?: string = uuid()
  type: 'grid' = 'grid'
  dependOn?: DependOnOption
  columns?: GridColumn[] = []
  options?: GridOptions = new GridOptions()
}

export class GridOptions {
  gutter = 24
}

export interface GridColumnReactive {
  span: number;
  offset?: number;
}

export class GridColumn {
  span?: number = 12
  offset?: number
  push?: number
  pull?: number
  xs?: number | GridColumnReactive
  sm?: number | GridColumnReactive
  md?: number | GridColumnReactive
  lg?: number | GridColumnReactive
  xl?: number | GridColumnReactive
  controls: Array<GridDef | FieldDef> = []
}
